import { Tron } from './Tron'

export { TronRes, TronChainId } from './constants'
export { tronErrors } from './tronError'

export const tron = new Tron()
